export default __webpack_public_path__ + "static/media/app-bar-account.e3923109.svg";